import Vue from 'vue';

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

function getCategories(): Promise<any> {
  return Vue.axios.get(`${apiUrl}/v1/forum/categories`);
}

export { getCategories };
